<dx-popup
  [visible]="visible"
  (onHidden)="onHidden($event)"
  [closeOnOutsideClick]="false"
  [dragEnabled]="true"
  [height]="'auto'"
  [maxHeight]="'90vh'"
  [resizeEnabled]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  [width]="560"
  [title]="title"
>
  <div *dxTemplate="let data of 'content'" class="composer">

    <!-- FACE 1: the form -->
    <div class="face form-face" #formFace *ngIf="face === 'form'">

      <div class="row">
        <div class="label">Audience</div>
        <div class="field">
          <dx-radio-group
            [(value)]="audience"
            [items]="[{value: 'user', text: 'One subordinate'}, {value: 'all', text: 'Everyone I manage'}]"
            displayExpr="text" valueExpr="value" layout="horizontal"
            (onValueChanged)="onAudienceChanged()"
          ></dx-radio-group>
        </div>
      </div>

      <div class="row" *ngIf="audience === 'user'">
        <div class="label">Recipient</div>
        <div class="field">
          <dx-select-box
            [(value)]="audienceUserId"
            [items]="subordinates"
            displayExpr="userName" valueExpr="userId"
            placeholder="Select a user…"
            (onValueChanged)="onAudienceUserChanged()"
          ></dx-select-box>
        </div>
      </div>

      <div class="row">
        <div class="label">Subject</div>
        <div class="field">
          <dx-select-box
            [(value)]="subjectPath"
            [items]="subjectChoices"
            [disabled]="isLoadingSubjects"
            displayExpr="label" valueExpr="path"
            (onValueChanged)="refresh()"
          ></dx-select-box>
        </div>
      </div>

      <div class="row">
        <div class="label">Severity</div>
        <div class="field">
          <dx-radio-group
            [(value)]="severity"
            [items]="severities"
            displayExpr="text" valueExpr="value"
            layout="horizontal"
            (onValueChanged)="refresh()"
          ></dx-radio-group>
        </div>
      </div>

      <!-- Send at FIRST, then Due, on one row (owner 2026-09-23): the due day can never be before the
           send day, so the due box's earliest day follows the send day. Empty Send at = now. -->
      <div class="row">
        <div class="label">Date, time</div>
        <div class="field two-up">
          <div class="sub">
            <div class="caption">Send at</div>
            <ets-datetime-picker class="send-at" mode="datetime" [showTimezone]="false" [showSeconds]="false" placeholder="now"
                                 [value]="sendAtWallClock" (valueChanged)="onSendAtChanged($event)"></ets-datetime-picker>
            <div class="hint" *ngIf="!sendTimeInPast">Empty = now. Time in {{ zoneLabel }}.</div>
            <div class="hint error" *ngIf="sendTimeInPast">Must be later than now.</div>
          </div>
          <div class="sub">
            <div class="caption">Due</div>
            <dx-date-box [(value)]="dueDate" type="date" displayFormat="EEE dd-MMM-yy" [min]="dueMin" [showClearButton]="true"
                         placeholder="send day" (onValueChanged)="refresh()"></dx-date-box>
            <div class="hint">Trading day to do it by. Empty = the send day.</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="label">Headline</div>
        <div class="field">
          <dx-text-box [(value)]="headline" [maxLength]="200" placeholder="One line, what to do"
                       valueChangeEvent="keyup" (onValueChanged)="refresh()"></dx-text-box>
        </div>
      </div>

      <div class="row">
        <div class="label">Body</div>
        <div class="field">
          <dx-text-area [(value)]="body" [height]="110" valueChangeEvent="keyup" (onValueChanged)="refresh()"></dx-text-area>
        </div>
      </div>

      <div class="buttons">
        <dx-button class="face-toggle" [text]="faceButtonText" (onClick)="toggleFace()"></dx-button>
        <div class="spacer"></div>
        <dx-button text="Cancel" (onClick)="hide()"></dx-button>
        <dx-button [text]="postButtonText" type="default" [disabled]="!canPost" (onClick)="post()"></dx-button>
      </div>

    </div>

    <!-- FACE 2: the sender's alerts waiting to be sent — minimized cards, an X to cancel (owner 2026-09-23).
         The face keeps the form's height; the list scrolls inside. -->
    <div class="face pending-face" *ngIf="face === 'pending'" [style.height.px]="faceHeight">

      <div class="pending">
        <div class="pending-error" *ngIf="pendingLoadError" role="alert">
          {{ pendingLoadError }}
          <dx-button text="Retry" (onClick)="loadPending()" [disabled]="isLoadingPending"></dx-button>
        </div>
        <div class="empty" *ngIf="!isLoadingPending && !pendingLoadError && pending.length === 0">No alerts waiting to be sent.</div>

        <div class="mini-card" *ngFor="let n of pending; trackBy: trackPending"
             [class.red]="n.severity === 'red'" [class.orange]="n.severity === 'orange'" [class.yellow]="n.severity === 'yellow'">
          <!-- Owner 2026-09-25: a strict two-column header (label cell + value cell per column, two rows),
               a rule, then the message as the user wrote it — bold headline, the body clamped to two lines.
               The colour says the level, so no level tag; no chips. -->
          <div class="header">
            <span class="label">Recipient</span>
            <span class="value">{{ recipientText(n) }}</span>
            <span class="label">Subject</span>
            <span class="value" [title]="subjectText(n)">{{ subjectText(n) }}</span>
            <button type="button" class="remove" title="Cancel this alert" [disabled]="cancellingId !== null"
                    (click)="cancelPending(n, $event)">✕</button>
            <span class="label">Send at</span>
            <span class="value">{{ formatSendAt(n.sendAtUtc) }}</span>
            <span class="label">Due</span>
            <span class="value">{{ formatDue(n) }}</span>
          </div>
          <div class="message">
            <div class="headline" [title]="n.headline">{{ n.headline }}</div>
            <div class="body" *ngIf="n.body">{{ n.body }}</div>
          </div>
        </div>
      </div>

      <div class="buttons">
        <dx-button class="face-toggle" [text]="faceButtonText" (onClick)="toggleFace()"></dx-button>
        <div class="spacer"></div>
        <dx-button text="Close" (onClick)="hide()"></dx-button>
      </div>

    </div>

  </div>
</dx-popup>

<!-- Owner 2026-09-25: cancelling a waiting alert is irreversible (cancel only, never edit), so it asks first.
     A sibling of the composer popup, not inside it: a dx-popup renders at the document body anyway. -->
<ets-generic-confirmation-dialog #cancelConfirm
                                 title="Cancel this alert?"
                                 confirmText="Yes"
                                 rejectText="No">
</ets-generic-confirmation-dialog>
